/** Body class while tower/raid/dungeon trial fight runs over home — hides home HUD bleed. */
export const TOWER_IMMERSIVE_BATTLE_BODY_CLASS = "tower-immersive-battle";

export function setTowerImmersiveBattle(active: boolean): void {
  document.body.classList.toggle(TOWER_IMMERSIVE_BATTLE_BODY_CLASS, active);
}
